"use strict";
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.baseQuery = void 0;
// Based on the generated query
exports.baseQuery = `
  query GetAssessments(
    $filter: AssessmentFilter
    $limit: Int
    $nextToken: AWSJSON
  ) {
    getAssessments(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        organizationID
        status
        type
        version
        description  
        deliveredRemotely
        isDemoTest
        workshopDate
        readoutDate
        mapProgramEngagementId
        opportunity {
          id
          name
        }
        engagement {
          id
          name
        }
        deliveredBy
        internalContact
        createAt
        createdBy
        updatedBy  
        updatedAt
        isfavorite     
        optOutSolutionsRecommendation
        sendAllPromptsToPreEvent
        targetSegmentId
        customerCloudMaturity
        customerPlanAndAlignment
        tags {
          key
          value
        }
        metadata {
          key
          value
        }
        assessmentScores {
          scoreType
          scoreDetails
        }
        ##SUB_QUERIES##
      }
      nextToken
    }
  }
`;
